import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import myEditor from '@/components/myEditor/index.vue'

import { parseTime, resetForm, handleTree, addBeginAndEndTime, divide} from "@/utils/ruoyi";

Vue.component('myEditor', myEditor)
Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false
// 全局方法挂载
Vue.prototype.handleTree = handleTree
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js